import React, {useEffect, useState, useContext} from 'react';
import HeaderView from "../../components/header/headerView";
import RoundStat from "../../components/stats/roundStat";
import CardStat from "../../components/stats/cardStat";
import Table from "../../components/table/table";
import Tag from "../../components/tag/tag";
import Dot from "../../components/dot/dot";
import Button from "../../components/button/button";
import useStatusName from "../../hooks/parseText/useStatusName";
import useOpenModal from "../../hooks/useOpenModal";
import TabBlock from "../../components/navbar/tabBlock";
import ActivitiesServices from "../../api/services/activities";
import ModalIsVerified from "../../components/modal/modalTable/modalIsVerified";
import FilterTable from "../../components/table/filterTable";
import useFilter from "../../hooks/useFilter";
import {ErrorContext} from "../../context/errorContext";
import {useLoader} from "../../context/loaderContext";
import useVerificationHandlers from "../../hooks/verification/entitiesVerification";

const VerificationActivities = () => {

    const [refresh, setRefresh] = useState(false);
    const [filterList, setFilterList] = useState([]);

    const [activities, setActivities] = useState([]);
    const { getStatusName } = useStatusName();
    const { showError } = useContext(ErrorContext);
    const { setLoading } = useLoader();

    const { handleActivitiesVerification } = useVerificationHandlers();


    const [isModalOpen, openModal, closeModal] = useOpenModal(activities.map(() => false));

    const { updateFilters, filteredData } = useFilter([], activities, (activity, filters, query) => {
        const matchesFilters = filters.length === 0 || filters.includes(activity.status);
        const matchesQuery = query === '' || activity.name.toLowerCase().includes(query.toLowerCase());
        return matchesFilters && matchesQuery;
    });

    const loadActivities = async () => {
        setLoading(true);
        try {
            // Récupérer uniquement les activités non vérifiées
            const response = await ActivitiesServices.getActivitiesToVerify();
            if(response.status === 200){
                // Filtrer pour ne garder que les activités non vérifiées (isVerified === false)
                const activitiesToVerify = response.data.filter(activity => !activity.isVerified);

                //sort last updated
                setActivities(activitiesToVerify.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)));
                setRefresh(false);

                setFilterList([...new Set(activitiesToVerify.map((activity) => activity.status))]);
            }
        } catch (error) {
            showError(error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        loadActivities();
    }, [refresh]);


    return (
        <div className={"main-container"}>
            <HeaderView title={`Vérification d'activités (${activities.length})`} actions={
                <>
                    <TabBlock
                        tabs={[
                            {name: "Partenaires", link: "/verification/partners"},
                            {name: "Activités", link: "/verification/activities"},
                            {name: "Offres", link: "/verification/offers"}
                        ]}
                        activeLink={1}
                    />
                </>
            }/>

            <div className={"main-container__row list"}>
                {
                    filterList && filterList.length > 0 ?
                        <FilterTable
                            filterArray={filterList}
                            onFilterChange={(data) => updateFilters(data)}
                            typeValue="activity"
                            searchData={activities}
                        />
                        :
                        null
                }
                {
                    activities.length === 0 ? (
                        // No activities at all
                        <div className={"container__empty"}>
                            <p className={"text-14"}>Aucune activitée à vérifier pour le moment</p>
                        </div>
                    ) : filteredData.length === 0 ? (
                        // No results found for the current search query
                        <div className={"container__empty"}>
                            <p className={"text-14"}>Aucune activitée ne correspond à votre recherche</p>
                        </div>
                    ) : (
                        <Table
                            columns={[
                                {name: "Référence", align: "left", width: "30%", field: "reference"},
                                {name: "Activité", align: "left", width: "30%", field: "activity"},
                                {name: "Status", align: "left", width: "20%", field: "status"},
                                {
                                    name: "Actions", align: "center", width: "30%", style: {
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }, field: "actions"
                                },
                                {
                                    name: "Voir plus", align: "center", width: "15%", style: {
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    },
                                    field: "link"
                                },
                            ]}

                            data={
                                filteredData && filteredData.length > 0 ?
                                    filteredData.map((activity, index) => {
                                            return {
                                                reference: activity.reference,
                                                activity: activity.name,
                                                status: <Tag text={getStatusName(activity.status)} status={activity.status}/>,
                                                actions: (
                                                    <Dot size={"big"} click={() => openModal(index)}>
                                                        <>
                                                            <ModalIsVerified
                                                                isOpen={isModalOpen[index]}
                                                                closeModal={() => closeModal(index)}
                                                                handleChange={(status) => handleActivitiesVerification(activity._id, activity.partnerID, status, setRefresh)}
                                                                type={"activity"}
                                                                link={`/partners/${activity.partnerID._id}/activities/${activity._id}`}
                                                            />
                                                        </>
                                                    </Dot>
                                                ),
                                                link: <Button text={"Voir le dossier"} link={`/partners/${activity.partnerID._id}/activities/${activity._id}`}/>
                                            }
                                        }
                                    ) : []
                            }
                        />
                    )
                }
            </div>
        </div>
    );


}

export default VerificationActivities;